export const SEARCH_PRICELIST_MODAL_EVENT = 'modals:pricelists:search';
export const SEARCH_PRICELIST_MODAL_OPEN = `${SEARCH_PRICELIST_MODAL_EVENT}:open`;
export const SEARCH_PRICELIST_MODAL_CLOSE = `${SEARCH_PRICELIST_MODAL_EVENT}:close`;
